import { render, staticRenderFns } from "./Rufgruppe_beantragen.vue?vue&type=template&id=74982d82&scoped=true"
import script from "./Rufgruppe_beantragen.vue?vue&type=script&lang=js"
export * from "./Rufgruppe_beantragen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74982d82",
  null
  
)

export default component.exports